import { graphql, useStaticQuery } from 'gatsby';

const useStoreSectionData = () => {
  const data = useStaticQuery(
    graphql`
      query STORESECTION_DATA_QUERY {
        markdownRemark(frontmatter: { templateKey: { eq: "store-section" } }) {
          frontmatter {
            title
            subtitle
            imageApp {
              childImageSharp {
                fluid(maxWidth: 650, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            imagePerson {
              childImageSharp {
                fixed(width: 502, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            imagePlayStore {
              childImageSharp {
                fixed(width: 140, quality: 64) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            imageAppStore {
              childImageSharp {
                fixed(width: 140, quality: 64) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        }
      }
    `,
  );
  return data.markdownRemark.frontmatter;
};

export default useStoreSectionData;
